module.exports = __webpack_public_path__ + "static/museo-c4da6ac8a5df6017b69a526007e2ffde.jpg";